module.exports = __webpack_public_path__ + "img/valores-mais-com-menos.33ec9207.svg";